export default __webpack_public_path__ + "static/media/img-1.7d8658df.png";